import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import installElementPlus from './plugins/element'
import * as ElIconModules from '@element-plus/icons'

import locale from 'element-plus/lib/locale/lang/zh-cn' //中文
import './element-variables.scss'
import './assets/icon-font/iconfont.css' //iconfot
import './assets/icon-font/iconfont.js' //iconfot
import './assets/icon-font2/iconfont.css' //iconfot
import './assets/icon-font2/iconfont.js' //iconfot
import './common/css/icon.css';
import './common/css/customer-theme.css';
import './common/css/customer-theme2.css';
import './common/css/customer-theme3.css';
import './common/css/customer-theme4.css';
import './common/css/customer-theme5.css';
import "./common/css/main.css";
import "./common/css/kfreset.css";
import "./common/css/public-style.css";
import "./common/css/color-dark.css";/*深色主题*/
import Emitter from 'tiny-emitter'
import moment from 'moment'
import common from './util/common'
import * as echarts from 'echarts'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import { ElMessageBox, ElMessage } from 'element-plus'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

const app = createApp(App)
// 统一注册Icon图标
for (const iconName in ElIconModules) {
    if (Reflect.has(ElIconModules, iconName)) {
      const item = ElIconModules[iconName]
      app.component(iconName, item)
    }
  }

installElementPlus(app)
const emitter = new Emitter()
// 绑定为全局可用
app.config.globalProperties.emitter = emitter
app.config.globalProperties.$moment = moment;
// Vue.prototype.$Message = bDesign.Message;
app.config.globalProperties.$common = common;
app.config.globalProperties.$echarts = echarts;
app.config.globalProperties.$message = ElMessage;
app.config.globalProperties.$messageBox = ElMessageBox;
app.config.globalProperties.loading = function () {
  const loading = this.$loading({
    lock: true,
    text: "加载中...",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  return loading;
}

app.directive("scrollBottom", {
  updated(el) {
   // 这里的el即是绑定指令处的dom元素
    el.scrollTo({
      top: el.scrollHeight - el.clientHeight,
      behavior: "smooth"
    })
  }
})

app.use(VueViewer)
app.use(VXETable).use(store).use(router).mount('#app')


